/* eslint-disable */
import { useEffect, useRef, useState } from 'react';
import { List, Collapse, makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import {
  ExpandMore,
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  Folder as ResourcesIcon,
  Settings as AdminIcon,
  Assessment as MonitoringIcon,
  Business as OrganizationIcon,
  Build as OperationsIcon,
} from '@material-ui/icons';
import { checkPermission } from 'helpers/checkPermissions';
import { useSelector, useDispatch } from 'react-redux';
import { setNavigationScrollPosition, selectBreadcrumbs } from '../../../../../../redux_store';
import NavItem from './NavItem';
import { ALL_ROUTES } from '../../../../../../config/routes';
import cx from 'classnames';
import { STORAGE_KEY } from './NavWrapper/constants';
import CollapsedMenu from './NavWrapper/CollapsedMenu';

const useStyles = makeStyles(theme => ({
  navigation: {
    marginTop: 42,
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    maskImage: 'linear-gradient(to bottom, black calc(100% - 60px), transparent 100%)',
    WebkitMaskImage: 'linear-gradient(to bottom, black calc(100% - 60px), transparent 100%)',
  },
  navGroup: {
    marginBottom: theme.spacing(1.5),
    opacity: 1,
    transition: 'all 0.2s linear',
  },
  groupHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 1.5, 1, 2),
    cursor: 'pointer',
    marginBottom: theme.spacing(0.5),
    transition: 'all 0.2s ease',
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.15)',
    },
  },
  collapsedGroupHeader: {
    padding: theme.spacing(1),
    justifyContent: 'center',
    minWidth: 48,
    minHeight: 48,
  },
  groupTitleSection: {
    display: 'flex',
    alignItems: 'center',
  },
  groupIcon: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: 20,
  },
  groupTitle: {
    color: 'rgba(255, 255, 255, 0.9)',
    fontSize: '0.75rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 1,
    transition: 'opacity 0.3s ease',
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(1),
  },

  hiddenTitle: {
    opacity: 0,
  },
  itemCount: {
    background: 'rgba(255, 255, 255, 0.2)',
    color: 'white',
    padding: theme.spacing(0.25, 0.75),
    borderRadius: 10,
    fontSize: '0.625rem',
    margin: theme.spacing(0, 0.75, 0, 1),
    minWidth: 16,
    textAlign: 'center',
  },
  groupExpand: {
    display: 'flex',
    alignItems: 'center',
  },
  expandIcon: {
    color: 'rgba(255, 255, 255, 0.6)',
    fontSize: 18,
    transition: 'transform 0.2s ease',
  },
  expandIconRotated: {
    transform: 'rotate(180deg)',
  },
  childrenContainer: {
    borderLeft: '2px solid rgba(255, 255, 255, 0.1)',
    marginLeft: theme.spacing(2.5),
  },
  driver: {
    borderTop: '1px solid rgba(255, 255, 255, 0.2)',
    margin: theme.spacing(1.5, 0),
  },
  popover: {
    pointerEvents: 'none',
    zIndex: 20000,
    '& .MuiPopover-paper': {
      overflow: 'visible',
      filter: 'drop-shadow(0px 8px 32px rgba(0, 0, 0, 0.12))',
      zIndex: 20001,
    },
  },
  popoverContent: {
    pointerEvents: 'auto',
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    border: '1px solid rgba(229, 231, 235, 0.6)',
    borderRadius: 12,
    minWidth: 220,
    maxWidth: 280,
    overflow: 'hidden',
    position: 'relative',
    marginLeft: 4, // Minimal gap for Apple-style positioning
    zIndex: 1002,
  },
  popoverHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1.25, 1.5),
    borderBottom: '1px solid rgba(229, 231, 235, 0.4)',
    background: 'rgba(249, 250, 251, 0.6)',
  },
  popoverHeaderIcon: {
    color: 'rgba(55, 65, 81, 0.8)',
    marginRight: theme.spacing(1),
    fontSize: 16,
  },
  popoverHeaderTitle: {
    color: 'rgba(17, 24, 39, 0.9)',
    fontSize: '0.75rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  popoverList: {
    padding: theme.spacing(0.5, 0),
  },
  popoverItem: {
    padding: theme.spacing(0.875, 1.5),
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    transition: 'all 0.15s cubic-bezier(0.4, 0.0, 0.2, 1)',
    position: 'relative',
    margin: theme.spacing(0, 0.5),
    borderRadius: 6,

    '&:hover': {
      backgroundColor: 'rgba(59, 130, 246, 0.08)',
      transform: 'translateX(2px)',

      '& $popoverItemText': {
        color: 'rgba(17, 24, 39, 0.9)',
      },
    },

    '&:active': {
      transform: 'translateX(1px) scale(0.98)',
    },
  },
  popoverItemIcon: {
    marginRight: theme.spacing(1.25),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 20,
    transition: 'color 0.15s ease',
    '& svg': {
      width: 16,
      height: 16,
      stroke: 'none !important',
      strokeWidth: '0 !important',
    },
  },
  popoverItemText: {
    color: 'rgba(55, 65, 81, 0.85)',
    fontSize: '0.825rem',
    fontWeight: 500,
    lineHeight: 1.4,
    transition: 'color 0.15s ease',
  },
  popoverItemSelected: {
    backgroundColor: 'rgba(59, 130, 246, 0.1)',
    border: '1px solid rgba(59, 130, 246, 0.25)',

    '& $popoverItemText': {
      color: 'rgba(37, 99, 235, 0.95)',
      fontWeight: 600,
    },

    '&:hover': {
      backgroundColor: 'rgba(59, 130, 246, 0.15)',
      transform: 'translateX(2px)',

      '& $popoverItemText': {
        color: 'rgba(37, 99, 235, 1)',
      },
    },
  },
  collapsedGroupActive: {
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
  },
  hideItem: {
    opacity: 0,
    transition: 'all 0.01s ease',
  },
}));

let hoverTimeout;
let timeout;

const NavWrapper = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const navigationRef = useRef(null);
  const dispatch = useDispatch();

  const NAV_GROUPS = [
    {
      id: 'organization',
      title: 'Organization',
      icon: OrganizationIcon,
      items: [
        { route: ALL_ROUTES.account.listDS, icon: ALL_ROUTES.account.listDS.additional.icon },
        { route: ALL_ROUTES.user.globalManagement, icon: ALL_ROUTES.user.globalManagement.additional.icon },
        // Hidden from navigation. The route stays registered in PRIVATE_ROUTES, so
        // /allergi-end-resources still resolves for anyone with a direct link and the
        // Documentation section keeps working. Uncomment to restore the tab.
        // {
        //   route: ALL_ROUTES.allergiEndResources.dashboard,
        //   icon: ALL_ROUTES.allergiEndResources.dashboard.additional.icon,
        // },
        // {
        //   route: ALL_ROUTES.instantAssessment.dashboard,
        //   icon: ALL_ROUTES.instantAssessment.dashboard.additional.icon,
        // },
      ],
    },
    {
      id: 'monitoring',
      title: 'Monitoring',
      icon: MonitoringIcon,
      items: [
        { route: ALL_ROUTES.dashboard.root, icon: ALL_ROUTES.dashboard.root.additional.icon },
        {
          route: ALL_ROUTES.dashboard.populationHealth,
          icon: ALL_ROUTES.dashboard.populationHealth.additional.icon,
        },
        // TEMP: Assessment Performance backport (2026-05-07) — orphan after FSD merge.
        {
          route: ALL_ROUTES.dashboard.assessmentPerformance,
          icon: ALL_ROUTES.dashboard.assessmentPerformance.additional.icon,
        },
        { route: ALL_ROUTES.alert.list, icon: ALL_ROUTES.alert.list.additional.icon },
      ],
    },
    {
      id: 'patient-care',
      title: 'Patient Care',
      icon: PeopleIcon,
      items: [
        { route: ALL_ROUTES.patient.list, icon: ALL_ROUTES.patient.list.additional.icon },
        { route: ALL_ROUTES.assessment.list, icon: ALL_ROUTES.assessment.list.additional.icon },
        { route: ALL_ROUTES.resource.list, icon: ALL_ROUTES.resource.list.additional.icon },
        { route: ALL_ROUTES.order.list, icon: ALL_ROUTES.order.list.additional.icon },
        { route: ALL_ROUTES.program.list, icon: ALL_ROUTES.program.list.additional.icon },
      ],
    },
  ];

  const NAV_ADMIN_GROUP = {
    id: 'operations',
    title: 'Operations',
    icon: OperationsIcon,
    items: [
      { route: ALL_ROUTES.claim.list, icon: ALL_ROUTES.claim.list.additional.icon },
      {
        route: ALL_ROUTES.reportable.list,
        icon: ALL_ROUTES.reportable.list.additional.icon,
        isChild: true,
      },
      {
        route: ALL_ROUTES.claimReport.list,
        icon: ALL_ROUTES.claimReport.list.additional.icon,
        isChild: true,
      },
      { route: ALL_ROUTES.botActivity.list, icon: ALL_ROUTES.botActivity.list.additional.icon },
    ],
  };
  // Load saved state from localStorage or use defaults
  const getInitialExpandedState = () => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        return JSON.parse(saved);
      }
    } catch (error) {
      console.warn('Failed to load navigation state from localStorage:', error);
    }

    // Default state if no saved state or on small screens
    return isSmallScreen ? {} : { monitoring: true, 'patient-care': true, organization: true };
  };

  const [expandedGroups, setExpandedGroups] = useState(getInitialExpandedState);
  const [popoverState, setPopoverState] = useState({
    anchorEl: null,
    groupId: null,
  });

  const setHoverTimeout = value => {
    hoverTimeout = value;
  };

  const {
    metadata: { currentAccountPermissions, currentAccount },
  } = useSelector(state => state.user);
  const { disabledFeatures, screenHeight, isSideMenuPinned, navigationScrollPosition } =
    useSelector(state => state.appSettings);
  const [hideDuringPinAnimation, setHideDuringPinAnimation] = useState(isSideMenuPinned);
  const breadcrumbs = useSelector(selectBreadcrumbs) || [];

  const toggleGroup = groupId => {
    setExpandedGroups(prev => {
      const newState = {
        ...prev,
        [groupId]: !prev[groupId],
      };

      // Save to localStorage
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(newState));
      } catch (error) {
        console.warn('Failed to save navigation state to localStorage:', error);
      }

      return newState;
    });
  };

  const handlePopoverOpen = (event, groupId) => {
    if (!isSideMenuPinned) {
      // Clear any existing timeout
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
        setHoverTimeout(null);
      }

      // If opening different group, close current immediately
      if (popoverState.groupId && popoverState.groupId !== groupId) {
        setPopoverState({
          anchorEl: event.currentTarget,
          groupId: groupId,
        });
      } else {
        setPopoverState({
          anchorEl: event.currentTarget,
          groupId: groupId,
        });
      }
    }
  };

  const handlePopoverCancelClose = () => {
    // Cancel close timeout when entering popover area
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
      setHoverTimeout(null);
    }
  };

  const handlePopoverDelayedClose = () => {
    // Add delay before closing
    const hoverTimeout = setTimeout(() => {
      setPopoverState({
        anchorEl: null,
        groupId: null,
      });
      setHoverTimeout(null);
    }, 300); // 300ms delay

    setHoverTimeout(hoverTimeout);
  };

  const getVisibleItems = items => {
    return items.filter(item => {
      if (!item.route?.additional?.permission) return true;
      return (
        checkPermission(currentAccountPermissions, item.route.additional.permission) &&
        !disabledFeatures.includes(item.route.additional.disabledId)
      );
    });
  };

  const renderGroup = (group, isAdmin = false) => {
    const visibleItems = getVisibleItems(group.items);
    if (visibleItems.length === 0) return null;

    const isExpanded = expandedGroups[group.id];
    const GroupIcon = group.icon;

    // Check if any item in this group is currently selected
    const isGroupActive = visibleItems.some(
      item =>
        breadcrumbs[0]?.title &&
        (breadcrumbs[0]?.title === item.route?.additional?.title ||
          breadcrumbs[0]?.title === item.route?.additional?.name)
    );

    // In collapsed mode, show only the group icon with click to open popover
    if (!hideDuringPinAnimation) {
      return (
        <div key={group.id} className={cx(classes.navGroup)}>
          {isAdmin && <div className={classes.driver} />}
          <div
            className={`${classes.groupHeader} ${classes.collapsedGroupHeader} ${
              isGroupActive ? classes.collapsedGroupActive : ''
            }`}
            onClick={e => handlePopoverOpen(e, group.id)}
            onMouseEnter={e => {
              handlePopoverCancelClose(); // Cancel any pending close
              handlePopoverOpen(e, group.id);
            }}
            onMouseLeave={handlePopoverDelayedClose}
          >
            <GroupIcon className={classes.groupIcon} />
          </div>
        </div>
      );
    }

    return (
      <div key={group.id} className={cx(classes.navGroup)}>
        {isAdmin && <div className={classes.driver} />}

        <div className={classes.groupHeader} onClick={() => toggleGroup(group.id)}>
          <div className={classes.groupTitleSection}>
            <GroupIcon className={classes.groupIcon} />
            <span
              className={`${classes.groupTitle} ${!isSideMenuPinned ? classes.hiddenTitle : ''}`}
            >
              {group.title}
            </span>
          </div>
          <div className={classes.groupExpand}>
            <ExpandMore
              className={`${classes.expandIcon} ${isExpanded ? classes.expandIconRotated : ''}`}
            />
          </div>
        </div>

        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
          <div className={classes.childrenContainer}>
            {visibleItems.map((item, index) => {
              // Create a modified route item with the icon
              const navItemData = {
                id: index,
                route: {
                  ...item.route,
                  additional: {
                    ...item.route.additional,
                    icon: item.icon,
                  },
                },
              };

              return (
                <NavItem
                  key={`${group.id}-${index}`}
                  item={navItemData}
                  isChild={item.isChild || false}
                />
              );
            })}
          </div>
        </Collapse>
      </div>
    );
  };

  // Check admin permissions
  const hasAdminPermissions = NAV_ADMIN_GROUP.items.some(item =>
    checkPermission(currentAccountPermissions, item.route?.additional?.permission)
  );

  // Auto-expand groups on larger screens (only if no saved state)
  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);

    // Only auto-expand if there's no saved state and we're on a large screen
    if (!saved && !isSmallScreen) {
      const defaultState = { monitoring: true, 'patient-care': true, organization: true };
      setExpandedGroups(defaultState);

      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(defaultState));
      } catch (error) {
        console.warn('Failed to save default navigation state to localStorage:', error);
      }
    }
  }, [isSmallScreen]);

  useEffect(() => {
    if (isSideMenuPinned) {
      timeout = setTimeout(() => {
        setHideDuringPinAnimation(true);
      }, 100);
    } else {
      setHideDuringPinAnimation(false);
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [isSideMenuPinned]);

  // Save scroll position on unmount or navigation change
  useEffect(() => {
    const handleScroll = () => {
      if (navigationRef.current) {
        dispatch(setNavigationScrollPosition(navigationRef.current.scrollTop));
      }
    };

    const navElement = navigationRef.current;
    if (navElement) {
      navElement.addEventListener('scroll', handleScroll);
      return () => navElement.removeEventListener('scroll', handleScroll);
    }
  }, [dispatch]);

  // Restore scroll position after render
  useEffect(() => {
    if (navigationRef.current && navigationScrollPosition > 0) {
      navigationRef.current.scrollTop = navigationScrollPosition;
    }
  });

  return (
    <>
      <List
        ref={navigationRef}
        style={{ maxHeight: screenHeight - 290 }}
        component="nav"
        className={classes.navigation}
      >
        {NAV_GROUPS.map(group => renderGroup(group))}

        {hasAdminPermissions && renderGroup(NAV_ADMIN_GROUP, true)}

        <div style={{ height: 30 }} />
      </List>

      {/* Popover for collapsed navigation */}
      <CollapsedMenu
        hoverTimeout={hoverTimeout}
        setHoverTimeout={setHoverTimeout}
        popoverState={popoverState}
        setPopoverState={setPopoverState}
        handlePopoverCancelClose={handlePopoverCancelClose}
        handlePopoverDelayedClose={handlePopoverDelayedClose}
        navGroups={NAV_GROUPS}
        navAdminGroups={NAV_ADMIN_GROUP}
      />
    </>
  );
};

export default NavWrapper;
